import { inject, Injectable } from '@angular/core';
import { OroService } from '../../oroservice';

@Injectable({ providedIn: 'root' })
export class DocumentService {
    private readonly oroService = inject(OroService);
    public documentCount: number = 0;

    constructor() {
        this.oroService.customerInfoLoaded.subscribe({
            next: async () => {
                try {
                    await this.refreshCount();
                } catch (error) {
                    console.error('Document count refresh failed:', error);
                }
            },
        });
    }

    public async refreshCount(): Promise<void> {
        this.documentCount = await this.oroService.get<number>('web/dokument/count');
    }

    public async getDocuments<TDocument = unknown>(): Promise<TDocument[]> {
        return (await this.oroService.get<TDocument[] | null>('web/dokument')) ?? [];
    }

    public async downloadZip(documents: unknown[]): Promise<void> {
        const filename = `Documents${this.oroService.getCurrentDateAsString()}.zip`;
        await this.oroService.postElementDownload('web/dokument/datazip', documents, 'application/zip', filename);
    }
}
